module.exports = require("./../../_gen/openfl/display/DisplayObjectRenderer");